(function showStyleguideVersion() {
	'use strict';
	var cookie = document.cookie.match(/styleguide\=[\w\d\-\_\/\@\.]+/g);
	var span;
	var version;
	var onload;
	if (!cookie || !cookie.length) { return; }
	cookie = cookie[0];
	version = cookie ? cookie.split('=')[1] : '';
	if (version && version.toLowerCase() !== 'prod') {
		span = document.createElement('span');
		span.className = 'dev-flag';
		span.setAttribute('data-sgv', version);
		onload = window.onload || function() {};
		window.onload = function() {
			onload();
			document.body.appendChild(span);
		};
	}
}());

// This deals with the focus states on the new combo forms

$(document).ready(function() {
	$('.combo-form-input-group input, .combo-form-input-group select').focus(function() {
		$(this).parent().addClass('is-active');
	}).blur(function() {
		$(this).parent().removeClass('is-active');
	});
});

/* global-header.js
This file exists in two places:

* styleguide/app/scripts/global-header.js (in the styleguide project, used by phpweb)
* webserver/static/js/global-header.js (in the webserver project, used by djangoweb)

Changes should be made in both places, until such time as djangoweb starts using
the styleguide as an included dependency. */

$(function() {
	var $globalHeader = $('.global-header');
	var GLOBAL_HEADER_ACTIVE_CLASS = 'navigation-is-active';
	var MENU_ACTIVE_CLASS = 'is-active';
	var menus = [];

	function showMenu(menu) {
		$.each(menus, function(i, menu) {
			hideMenu(menu);
		});
		$globalHeader.addClass(GLOBAL_HEADER_ACTIVE_CLASS);
		menu.$menuContent.addClass(MENU_ACTIVE_CLASS);
		menu.$menuTrigger.addClass(MENU_ACTIVE_CLASS);

		function dismissingHandler(evt) {
			if (evt.type === 'touchend' && $.contains(menu.$menu[0], evt.target)) {
				return;
			}
			hideMenu(menu);
			removeDismissingHandler(menu);
		}

		function removeDismissingHandler(menu) {
			$(document).off('click touchend', dismissingHandler);
		}

		function attachDismissingHandler(menu) {
			// Not $().one, because that executes the handler once *per event type*.
			// We need to clear BOTH handlers as soon as EITHER is triggered.
			$(document).on('click touchend', dismissingHandler);
		}

		attachDismissingHandler(menu);
	}

	function hideMenu(menu) {
		$globalHeader.removeClass(GLOBAL_HEADER_ACTIVE_CLASS);
		menu.$menuContent.removeClass(MENU_ACTIVE_CLASS);
		menu.$menuTrigger.removeClass(MENU_ACTIVE_CLASS);
	}

	function toggleMenu(menu) {
		if (menu.$menuTrigger.hasClass(MENU_ACTIVE_CLASS)) {
			hideMenu(menu);
		} else {
			showMenu(menu);
		}
	}

	function makeMenu() {
		var $menu = $(this);
		var menu = {
			$menu: $menu,
			$menuTrigger: $menu.find('[data-role=global-header-menu-trigger]'),
			$menuContent: $menu.find('[data-role=global-header-menu-content]')
		};

		menus.push(menu);

		menu.$menuTrigger.click(function(evt) {
			evt.preventDefault();
			evt.stopPropagation();
			toggleMenu(menu);
		});
	}

	$('[data-role=global-header-menu]').each(makeMenu);
});

/*!
 * CSS Modal
 * http://drublic.github.com/css-modal
 *
 * @author Hans Christian Reinl - @drublic
 * @version 1.0.1
 */

(function(global) {
	'use strict';

	// Storage variable
	var modal = {};

	// Store for currently active element
	modal.lastActive = undefined;
	modal.activeElement = undefined;

	// Polyfill addEventListener for IE8 (only very basic)
	document._addEventListener = document.addEventListener || function(event, callback) {
		document.attachEvent('on' + event, callback);
	};

	// Hide overlay when ESC is pressed
	document._addEventListener('keyup', function(event) {
		var hash = window.location.hash.replace('#', '');

		// If hash is not set
		if (hash === '' || hash === '!') {
			return;
		}

		// If key ESC is pressed
		if (event.keyCode === 27) {
			window.location.hash = '!';

			if (modal.lastActive) {
				return false;
			}

			// Unfocus
			modal.removeFocus();
		}
	}, false);

	// Conveniance function to trigger event
	modal._dispatchEvent = function(event, modal) {
		var eventTigger;

		if (!document.createEvent) {
			return;
		}

		eventTigger = document.createEvent('Event');

		eventTigger.initEvent(event, true, true);
		eventTigger.customData = { 'modal': modal };

		document.dispatchEvent(eventTigger);
	};

	// When showing overlay, prevent background from scrolling
	window.onhashchange = function() {
		var hash = window.location.hash.replace('#', '');
		var modalElement = document.getElementById(hash);
		var modalChild;

		// If the hash element exists
		if (modalElement) {
			// Get first element in selected element
			modalChild = modalElement.children[0];

			// When we deal with a modal and class `has-overlay` is not set on html yet
			if (modalChild && modalChild.className.match(/modal-inner/) && !document.documentElement.className.match(/has-overlay/)) {
				// Set an html class to prevent scrolling
				document.documentElement.className += ' has-overlay';

				// Mark modal as active
				modalElement.className += ' is-active';
				modal.activeElement = modalElement;

				// Set the focus to the modal
				modal.setFocus(hash);

				// Fire an event
				modal._dispatchEvent('cssmodal:show', modal.activeElement);
			}
		} else {
			document.documentElement.className = document.documentElement.className.replace(' has-overlay', '');

			// If activeElement is already defined, delete it
			if (modal.activeElement) {
				modal.activeElement.className = modal.activeElement.className.replace(' is-active', '');

				// Fire an event
				modal._dispatchEvent('cssmodal:hide', modal.activeElement);

				// Reset active element
				modal.activeElement = null;

				// Unfocus
				modal.removeFocus();
			}
		}
	};

	/*
	 * Accessibility
	 */

	// Focus modal
	modal.setFocus = function() {
		if (modal.activeElement) {
			// Set element with last focus
			modal.lastActive = document.activeElement;

			// New focussing
			modal.activeElement.focus();
		}
	};

	// Unfocus
	modal.removeFocus = function() {
		if (modal.lastActive) {
			modal.lastActive.focus();
		}
	};

	global.CSSModal = modal;
}(window));

// Wait until the DOM has loaded before querying the document
$(document).ready(function() {
	$('.tabs').each(function() {
		// For each set of tabs, we want to keep track of
		// which tab is active and it's associated content
		var $active;
		var $content;
		var $links = $(this).find('a');

		// Use the first link as the initial active tab
		$active = $links.first().addClass('is-active');
		$content = $($active.attr('href'));

		// Hide the remaining content
		$links.not(':first').each(function() {
			$($(this).attr('href')).hide();
		});

		// Bind the click event handler
		$(this).on('click', 'a', function(e) {
			// Make the old tab inactive.
			$active.removeClass('is-active');
			$content.hide();

			// Update the variables with the new link and content
			$active = $(this);
			$content = $($(this).attr('href'));

			// Make the tab active.
			$active.addClass('is-active');
			$content.show();

			// Prevent the anchor's default click action
			e.preventDefault();
		});
	});
});
